module.exports = __webpack_public_path__ + "img/user-no-img2.3c4c791.png";